import * as React from 'react';
import * as Modal from 'react-modal';
import {StatelessComponent} from 'react';
import './styles.sass';

interface IVideoSettingsModalProps {
  children?: any;
  isOpen?: boolean;
  onAfterOpen?: () => void;
  onClose?: () => void;
}

export const VideoSettingsModal: StatelessComponent<IVideoSettingsModalProps> = ({
  children,
  isOpen,
  onAfterOpen,
  onClose,
}: IVideoSettingsModalProps) => (
  <Modal
    shouldFocusAfter={true}
    overlayClassName={'video-settings-modal_overlay'}
    contentLabel={'VideoSettingsModal'}
    ariaHideApp={false}
    className={'video-settings-modal'}
    isOpen={isOpen}
    onRequestClose={onClose}
    onAfterOpen={onAfterOpen}
  >
    {children}
  </Modal>
);
